import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { version } from '../../../../../package.json'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import { Collapse, Divider, Drawer, List, ListItem, Typography } from '@mui/material'
import { withStyles } from '@mui/styles'
import ArchitectureOutlinedIcon from '@mui/icons-material/ArchitectureOutlined';
import ApprovalOutlinedIcon from '@mui/icons-material/ApprovalOutlined';
import BuildIcon from '@mui/icons-material/Build';
import DesignServicesOutlinedIcon from '@mui/icons-material/DesignServicesOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalculateIcon from '@mui/icons-material/Calculate';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ConstructionIcon from '@mui/icons-material/Construction';
import PercentIcon from '@mui/icons-material/Percent';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TimelineIcon from '@mui/icons-material/Timeline';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LinkIcon from '@mui/icons-material/Link';
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import HomeIcon from '@mui/icons-material/Home';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import PublicIcon from '@mui/icons-material/Public';
import { authActions } from '../../../../_actions'
import { connect, useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Profile, SidebarNav } from './components'

const styles = (theme) => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(1, 0),
    color: '#1C5585'
  }
})

const Sidebar = ({ staticContext, ...props }) => {

  const { open, variant, onClose, className, ...rest } = props
  const dispatch = useDispatch()
  const { user } = props
  const [openMenuLinks, setOpenMenuLinks] = useState(false);
  const [openMenuCadastros, setOpenMenuCadastros] = useState(false);
  const [openMenuOrcamentos, setOpenMenuOrcamentos] = useState(false);
  const [openMenuRelatorios, setOpenMenuRelatorios] = useState(false);
  const [isClickedOptionSubmenu, setIsClickedOptionSubMenu] = useState(false);

  const isEmpresaProjeto = user.usuariosEmpresas && user.usuariosEmpresas[0]?.empresa?.projeto;
  const isEmpresaFornecedorMateriais = user.usuariosEmpresas && user.usuariosEmpresas[0]?.empresa?.fornecedor;
  const isPrestador = user.usuariosEmpresas && user.usuariosEmpresas[0]?.empresa?.prestadorServico;

  const logout = () => {
    dispatch(authActions.logout())
  }

  const { classes } = props

  const isDisabled = useSelector((state) => {
    return false
  })

  const handleClickCadastros = () => {
    setOpenMenuCadastros(!openMenuCadastros);
  };

  const handleClickOrcamentos = () => {
    setOpenMenuOrcamentos(!openMenuOrcamentos);
  };

  const handleClickLinks = () => {
    setOpenMenuLinks(!openMenuLinks);
  };

  const handleClickRelatorios = () => {
    setOpenMenuRelatorios(!openMenuRelatorios);
  };

  const pages = [
    {
      title: 'Home',
      href: '/',
      icon: <HomeIcon />
    },
    {
      disabled: isDisabled,
      title: 'Cadastros',
      clicked: openMenuCadastros,
      href: '#',
      rule: 'dashboard',
      icon: <AddCircleIcon />,
      onClick: () => {
        handleClickCadastros()
      }
    }
  ]

  const pagesFiscal = [
    {
      title: 'Home',
      href: '/',
      icon: <HomeIcon />
    }
  ]

  const pageAjuda = [
    {
      title: 'Ajuda',
      href: '/manuais',
      //por hora, só está disponível para 3 nívels de usuários
      rule: 'manuais.list',
      icon: <HelpOutlineOutlinedIcon />
    }
  ]

  const pagesLinks = [
    {
      disabled: isDisabled,
      title: 'Links',
      clicked: openMenuLinks,
      href: '#',
      rule: 'dashboard',
      icon: <LinkIcon />,
      onClick: () => {
        handleClickLinks()
      }
    }
  ]

  const pagesRelatorios = [
    {
      disabled: isDisabled,
      title: 'Relatórios',
      clicked: openMenuRelatorios,
      href: '#',
      rule: 'dashboard',
      icon: <SummarizeOutlinedIcon />,
      onClick: () => {
        handleClickRelatorios()
      }
    }
  ]

  const pagesOrcamentos = [
    {
      disabled: isDisabled,
      title: 'Propostas',
      clicked: openMenuOrcamentos,
      href: '#',
      rule: 'obrasOrcamentos.list',
      icon: <AttachMoneyIcon />,
      onClick: () => {
        handleClickOrcamentos()
      }
    }
  ]

  const pagesPadrao = [
    {
      title: 'Obras',
      href: '/obras',
      icon: <ConstructionIcon />,
      rule: 'obras.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true);
      },
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu
    },
    {
      title: 'Materiais',
      href: '/materiais',
      icon: <ShoppingCartIcon />,
      rule: 'obras.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true);
      },
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu
    },
    {
      title: 'Projetos Técnicos',
      href: '/projetosTecnicos',
      icon: <ArchitectureOutlinedIcon />,
      rule: 'obras.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true);
      },
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu
    },
    {
      title: 'Reparos/Prevenções',
      href: '/reparosPrevencoes',
      icon: <BuildIcon />,
      rule: 'obras.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true);
      },
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu
    }
  ];

  let pagesObra = [];

  // Verifica se o usuário é um gestor
  if (authActions.isGestor() || authActions.isPrefeitura() || authActions.isFiscal()) {
    pagesObra = pagesPadrao; // Exibe todas as opções
  } else {
    // Adiciona "Projetos Técnicos" para empresa de projeto
    if (isEmpresaProjeto) {
      pagesObra.push({
        title: 'Projetos Técnicos',
        href: '/projetosTecnicos',
        icon: <ArchitectureOutlinedIcon />,
        rule: 'obras.list',
        onClick: () => {
          setIsClickedOptionSubMenu(true);
        },
        disabled: isDisabled,
        clickedSub: isClickedOptionSubmenu
      });
    }

    // Adiciona "Materiais" para fornecedor de materiais
    if (isEmpresaFornecedorMateriais) {
      pagesObra.push({
        title: 'Materiais',
        href: '/materiais',
        icon: <ShoppingCartIcon />,
        rule: 'obras.list',
        onClick: () => {
          setIsClickedOptionSubMenu(true);
        },
        disabled: isDisabled,
        clickedSub: isClickedOptionSubmenu
      });
    }

    // Adiciona as páginas padrão para outros tipos de empresa
    if ((!isEmpresaProjeto && !isEmpresaFornecedorMateriais) || isPrestador) {
      pagesObra.push(
        {
          title: 'Obras',
          href: '/obras',
          icon: <ConstructionIcon />,
          rule: 'obras.list',
          onClick: () => {
            setIsClickedOptionSubMenu(true);
          },
          disabled: isDisabled,
          clickedSub: isClickedOptionSubmenu
        },
        {
          title: 'Reparos/Prevenções',
          href: '/reparosPrevencoes',
          icon: <BuildIcon />,
          rule: 'obras.list',
          onClick: () => {
            setIsClickedOptionSubMenu(true);
          },
          disabled: isDisabled,
          clickedSub: isClickedOptionSubmenu
        }
      );
    }
  }

  const pagesEmpenhos = [
    {
      title: 'Empenhos',
      href: '/empenhos',
      icon: <LocationCityIcon />,
      rule: 'empenhos.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu
    }
  ]

  const pagesObraMedicao = [
    {
      title: 'Medições',
      href: '/obrasCronogramas',
      icon: <TimelineIcon />,
      rule: 'obrasMedicoes.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu
    }
  ]

  const pagesObraCobrancas = [
    {
      title: 'Cobranças',
      href: '/obrasCobrancas',
      icon: <CreditCardIcon />,
      rule: 'obrasCobrancas.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu
    }
  ]

  const pagesSubOrcamentos = [
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Obras Aguardando Propostas',
      href: '/obrasAguardandoOrcamento',
      rule: 'obrasOrcamentos.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <AccessTimeIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Propostas Enviadas',
      href: '/obrasOrcamentos',
      rule: 'obrasOrcamentos.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <ContentPasteGoIcon />
    },
  ]

  const pagesSubLinks = [

    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'BDI',
      href: '/bdi',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <PercentIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'CalcMat',
      href: '/calcMat',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <CalculateIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Diário',
      href: '/diario',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <CalendarMonthIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Gov.Br',
      href: '/links-uteis',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <PublicIcon />
    }
  ]

  const pagesSubRelatorios = [
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Empresas por Órgão',
      href: '/relatorioEmpresasPorOrgao',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <ApprovalOutlinedIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Empresas por Tipo de Serviço',
      href: '/relatorioEmpresasPorTipoServico',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <DesignServicesOutlinedIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Ocorrências de Obras',
      href: '/relatorioOcorrenciasObra',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <CorporateFareIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Propostas Enviadas por Empresa',
      href: '/relatorioEmpresasOrcamentosEnviados',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <AttachMoneyIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Usuários',
      href: '/relatorioUsuarios',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <GroupsIcon />
    }
  ]

  const pagesSubRelatoriosPrefeitura = [
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Empresas por Órgão',
      href: '/relatorioEmpresasPorOrgao',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <ApprovalOutlinedIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Empresas por Tipo de Serviço',
      href: '/relatorioEmpresasPorTipoServico',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <DesignServicesOutlinedIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Ocorrências de Obras',
      href: '/relatorioOcorrenciasObra',
      rule: 'dashboard',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <CorporateFareIcon />
    },
  ]

  const pagesSair = [
    {
      title: 'Sair',
      href: '/login',
      icon: <ExitToAppIcon />,
      onClick: () => {
        logout()
      }
    }
  ]

  const pagesCadastrosItensGestor = [
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Empresas',
      href: '/empresas',
      rule: 'empresas.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <WorkOutlineIcon />
    },
    {
      disabled: isDisabled,
      title: 'Notificações',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      clickedSub: isClickedOptionSubmenu,
      href: '/notificacoes',
      rule: 'notificacoes',
      icon: <NotificationsIcon />
    },
    {
      disabled: isDisabled,
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Órgãos',
      href: '/orgaos',
      rule: 'orgaos.list',
      icon: <BusinessIcon />
    },
    {
      disabled: isDisabled,
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Parâmetros',
      href: '/parametros',
      rule: 'parametros.list',
      icon: <SettingsIcon />
    },
    {
      disabled: isDisabled,
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Sub Órgãos',
      href: '/subOrgaos',
      rule: 'subOrgaos.list',
      icon: <CorporateFareIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Usuários',
      href: '/usuarios',
      rule: 'usuarios.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <PeopleIcon />
    }
  ]

  const pagesCadastrosItensEmpresa = [
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Empresas',
      href: '/empresas',
      rule: 'empresas.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <WorkOutlineIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Usuários',
      href: '/usuarios',
      rule: 'usuarios.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <PeopleIcon />
    }
  ]

  const pagesCadastrosItensPrefeitura = [
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Empresas',
      href: '/empresas',
      rule: 'empresas.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <WorkOutlineIcon />
    },
    {
      disabled: isDisabled,
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Órgãos',
      href: '/orgaos',
      rule: 'orgaos.list',
      icon: <BusinessIcon />
    },
    {
      disabled: isDisabled,
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      clickedSub: isClickedOptionSubmenu,
      title: 'Sub Órgãos',
      href: '/subOrgaos',
      rule: 'subOrgaos.list',
      icon: <CorporateFareIcon />
    },
    {
      disabled: isDisabled,
      clickedSub: isClickedOptionSubmenu,
      title: 'Usuários',
      href: '/usuarios',
      rule: 'usuarios.list',
      onClick: () => {
        setIsClickedOptionSubMenu(true)
      },
      icon: <PeopleIcon />
    }
  ]

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <PerfectScrollbar style={{ height: 'calc(100% - 64px)' }}>
        <div {...rest} className={clsx(classes.root, className)}>
          <Profile user={user} />
          {!authActions.isFiscal() && <Divider className={classes.divider} />}
          {!authActions.isFiscal() ? <SidebarNav pages={pages} /> : <SidebarNav pages={pagesFiscal} />}
          {authActions.isGestor() &&
            <div style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
              <Collapse in={openMenuCadastros} timeout="auto">
                <List component="div" disablePadding>
                  <ListItem style={{ paddingTop: 0 }}>
                    <SidebarNav pages={pagesCadastrosItensGestor} style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }} />
                  </ListItem>
                </List>
              </Collapse>
            </div>
          }
          {authActions.isEmpresa() &&
            <div style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
              <Collapse in={openMenuCadastros} timeout="auto">
                <List component="div" disablePadding>
                  <ListItem style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                    <SidebarNav pages={pagesCadastrosItensEmpresa} style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }} />
                  </ListItem>
                </List>
              </Collapse>
            </div>
          }
          {authActions.isPrefeitura() &&
            <div style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
              <Collapse in={openMenuCadastros} timeout="auto">
                <List component="div" disablePadding>
                  <ListItem style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                    <SidebarNav pages={pagesCadastrosItensPrefeitura} style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }} />
                  </ListItem>
                </List>
              </Collapse>
            </div>
          }
          <Divider className={classes.divider} />
          {(authActions.isPrefeitura() || authActions.isGestor() || authActions.isEmpresa() || authActions.isFiscal()) &&
            <>
              <SidebarNav pages={pagesObra} />
              <Divider className={classes.divider} />
            </>
          }
          {(authActions.isPrefeitura() || authActions.isGestor()) &&
            <>
              <SidebarNav pages={pagesEmpenhos} />
              <Divider className={classes.divider} />
            </>
          }
          {(authActions.isFiscal()) && <>
            <SidebarNav pages={pagesObraMedicao} />
            <Divider className={classes.divider} />
          </>
          }
          {(authActions.isEmpresa() || authActions.isGestor()) &&
            <>
              <SidebarNav pages={pagesObraMedicao} />
              <Divider className={classes.divider} />
              <SidebarNav pages={pagesOrcamentos} />
              <div style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                <Collapse in={openMenuOrcamentos} timeout="auto">
                  <List component="div" disablePadding>
                    <ListItem style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                      <SidebarNav pages={pagesSubOrcamentos} style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }} />
                    </ListItem>
                  </List>
                </Collapse>
              </div>
              <Divider className={classes.divider} />
              <SidebarNav pages={pagesObraCobrancas} />
              <Divider className={classes.divider} />
            </>
          }
          {(authActions.isGestor() && !authActions.isUsuarioOrgaoPublico()) && //liberado para admin e prefeitura
            <>
              <SidebarNav pages={pagesRelatorios} />
              <div style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                <Collapse in={openMenuRelatorios} timeout="auto">
                  <List component="div" disablePadding>
                    <ListItem style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                      <SidebarNav pages={pagesSubRelatorios} style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }} />
                    </ListItem>
                  </List>
                </Collapse>
              </div>
              <Divider className={classes.divider} />
            </>
          }
          {(authActions.isPrefeitura()) && //liberado para admin e prefeitura
            <>
              <SidebarNav pages={pagesRelatorios} />
              <div style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                <Collapse in={openMenuRelatorios} timeout="auto">
                  <List component="div" disablePadding>
                    <ListItem style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                      <SidebarNav pages={pagesSubRelatoriosPrefeitura} style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }} />
                    </ListItem>
                  </List>
                </Collapse>
              </div>
              <Divider className={classes.divider} />
            </>
          }
          <SidebarNav pages={pagesLinks} />
          <div style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
            <Collapse in={openMenuLinks} timeout="auto">
              <List component="div" disablePadding>
                <ListItem style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }}>
                  <SidebarNav pages={pagesSubLinks} style={{ paddingTop: 0, paddingBottom: 0, marginBottom: 0 }} />
                </ListItem>
              </List>
            </Collapse>
          </div>
          {!authActions.isFiscal() && !authActions.isUsuarioOrgaoPublico() ?
            <>
              <Divider className={classes.divider} />
              <SidebarNav pages={pageAjuda} stye={{ marginBottom: 20 }} />
            </>
            : null
          }
          <Divider className={classes.divider} />
          <SidebarNav pages={pagesSair} />
          <Typography variant="subtitle2" align="center" style={{ fontSize: 10, marginTop: 2 }}>
            Versão do sistema: {version}
          </Typography>
        </div>
      </PerfectScrollbar>
    </Drawer>
  )
}

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
}

const mapStateToProps = (state) => {
  return {
    user: state.authentication.user
  }
}
const connectedSidebarPage = withRouter(
  //connect(mapStateToProps, null, null, {
  //  pure: false
  //})(withStyles(styles)(Sidebar))
  connect(mapStateToProps, null, null)(withStyles(styles)(Sidebar))
)
export { connectedSidebarPage as Sidebar }
